import React from "react"
import Icon, { IIconProps } from "./icon"

function StudentLifeIcon(props: IIconProps): JSX.Element {
  return (
    <Icon {...props}>
      <g>
        <path d="m5.6,20.79c-0.03,0 -0.06,0 -0.08,0a0.91,0.91 0 0 1 -0.82,-0.69l-0.43,-1.67l-0.09,0.02a2.15,2.15 0 0 1 -2.62,-1.55l-1.26,-4.9a2.15,2.15 0 0 1 1.55,-2.62l5.86,-1.53a0.45,0.45 0 0 1 0.23,0.88l-5.86,1.53a1.25,1.25 0 0 0 -0.9,1.51l1.26,4.9a1.25,1.25 0 0 0 1.51,0.9l0.98,-0.25l0.65,2.55a0.02,0.02 0 0 0 0.03,0.01l1.42,-3.09l4.58,-1.17a1.23,1.23 0 0 0 0.62,-0.38a0.45,0.45 0 1 1 0.68,0.61a2.15,2.15 0 0 1 -1.08,0.66l-4.16,1.06l-1.22,2.69a0.91,0.91 0 0 1 -0.84,0.54" />
        <path d="m18.54,18.07a1,1 0 0 1 -0.86,-0.5l-1.79,-3.04l-5.04,-0.74a2.46,2.46 0 0 1 -2.07,-2.79l0.87,-5.9a2.46,2.46 0 0 1 2.79,-2.07l9.19,1.35a2.46,2.46 0 0 1 2.07,2.79l-0.87,5.9a2.46,2.46 0 0 1 -2.79,2.07l-0.19,-0.03l-0.3,2.09a1.02,1.02 0 0 1 -1.01,0.86m-7.56,-5.17l5.47,0.8l2,3.41a0.09,0.09 0 0 0 0.11,0.05a0.09,0.09 0 0 0 0.08,-0.08l0.44,-2.99l1.09,0.16a1.55,1.55 0 0 0 1.76,-1.31l0.87,-5.9a1.55,1.55 0 0 0 -1.31,-1.76l-9.2,-1.35a1.55,1.55 0 0 0 -1.76,1.31l-0.87,5.9a1.55,1.55 0 0 0 1.31,1.76" />
        <path d="m14.3,8.79a0.69,0.69 0 1 1 -0.58,-0.78a0.69,0.69 0 0 1 0.58,0.78" />
        <path d="m16.92,9.17a0.69,0.69 0 1 1 -0.58,-0.78a0.69,0.69 0 0 1 0.58,0.78" />
        <path d="m19.55,9.56a0.69,0.69 0 1 1 -0.58,-0.78a0.69,0.69 0 0 1 0.58,0.78" />
        <path d="m6.5,12.95a0.6,0.6 0 1 0 0.43,-0.73a0.6,0.6 0 0 0 -0.43,0.73" />
        <path d="m4.28,13.51a0.6,0.6 0 1 0 0.43,-0.73a0.6,0.6 0 0 0 -0.43,0.73" />
      </g>
    </Icon>
  )
}

export default StudentLifeIcon
